import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export default function LoginLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    // This effect will run when the url changes
    const currentPage = window.location.pathname.substring(1);
    const storedUser = localStorage.getItem("currentUser");
    const storedUserObject = storedUser ? JSON.parse(storedUser) : null;

    // anyone should be able to access these pages,
    if (["login", "login/signup"].includes(currentPage)) {
      return;
    }

    // redirect user if they are trying to access a page
    // they are not authorized to access
    if (!storedUserObject) {
      if (
        [
          "login/emailVerification",
          "login/mobileVerification",
          "login/enterotp",
          "login/newusername",
          "login/selectavatar",
          "login/welcome",
        ].includes(currentPage)
      ) {
        // you must be logged in to view these pages
        return navigate("/login");
      }
    } else {
      // you should not be able to see these pages when logged in
      if (
        ["login/forgotpassword", "login/resetPassword"].includes(currentPage)
      ) {
        return navigate("/login");
      }
    }

    if (!storedUserObject?.emailIsVerified) {
      if (
        [
          "login/mobileVerification",
          "login/enterotp",
          "login/newusername",
          "login/selectavatar",
          "login/welcome",
        ].includes(currentPage)
      ) {
        // email not verified and page requires email verification
        return navigate("/login/emailVerification");
      } else {
        // email not verified and page does not require verification
        return;
      }
    } else {
      if (["login/emailVerification"].includes(currentPage)) {
        // email already verified and visiting EmailVerifcationPage
        return navigate("/login/mobileVerification");
      }
    }

    // Mobile verification is optional — only gate the enterotp page
    if (!storedUserObject?.mobileIsVerified) {
      if (["login/enterotp"].includes(currentPage) && !storedUserObject?.mobile) {
        return navigate("/login/mobileVerification");
      }
    } else {
      if (
        ["login/mobileVerification", "login/enterotp"].includes(currentPage)
      ) {
        // mobile verified and visiting mobile verification page
        return navigate("/login/selectavatar");
      }
    }

    if (storedUserObject?.username) {
      if (["login/newusername", "login/selectavatar"].includes(currentPage)) {
        // user has already set username (complete registration)
        return navigate("/login/welcome");
      }
    }
  }, [window.location.pathname]);

  return <Outlet />;
}
